import React, { useEffect, useState, useMemo } from "react";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";

const CHWeightSidingWise = ({ data }) => {
  const [chartDataSidingWise, setChartDataSidingWise] = useState(null);

  // Transform data function
  const transformYearlyData = useMemo(() => {
    return (data) => {
      const allYearKeys = new Set();
      const groupMap = {};
      let greatestYear = null;
      const uniqueTargets = {};

      // Step 1: Identify all years and find the greatest year
      data.forEach((yearEntry) => {
        const year = yearEntry.F_YEAR; // e.g., "2023_24"
        allYearKeys.add(year);
        if (!greatestYear || year > greatestYear) {
          greatestYear = year;
        }
      });

      // Step 2: Process data, including unique TGT_CH_WEIGHT for the greatest year
      data.forEach((yearEntry) => {
        const year = yearEntry.F_YEAR;
        const yearKey = year;
        const isGreatestYear = year === greatestYear;
        const yearTargetKey = `${year}_target`;

        if (isGreatestYear) {
          allYearKeys.add(yearTargetKey);
        }

        yearEntry.commodities_data.forEach((group) => {
          group.group_commodities_data.forEach((subGroup) => {
            subGroup.sub_commodities_data.forEach((commodity) => {
              commodity.months_data.forEach((monthEntry) => {
                monthEntry.data.forEach((dataEntry) => {
                  const fromStn = dataEntry.FROM_STN;
                  if (!fromStn) return;

                  if (!groupMap[fromStn]) {
                    groupMap[fromStn] = { product: fromStn };
                    if (isGreatestYear) {
                      uniqueTargets[fromStn] = new Set();
                    }
                  }

                  // Accumulate WAGON total
                  const yearChWeightTotal =
                    parseFloat(groupMap[fromStn][yearKey] || 0) +
                    parseFloat(dataEntry.CH_WEIGHT || 0);
                  groupMap[fromStn][yearKey] = yearChWeightTotal.toFixed(2);

                  // Accumulate unique TGT_CH_WEIGHT for the greatest year
                  if (isGreatestYear) {
                    const targetKey = dataEntry.TGT_CH_WEIGHT?.toString();
                    if (targetKey && !uniqueTargets[fromStn].has(targetKey)) {
                      const yearTargetTotal =
                        parseFloat(groupMap[fromStn][yearTargetKey] || 0) +
                        parseFloat(dataEntry.TGT_CH_WEIGHT || 0);
                      groupMap[fromStn][yearTargetKey] =
                        yearTargetTotal.toFixed(2);
                      uniqueTargets[fromStn].add(targetKey);
                    }
                  }
                });
              });
            });
          });
        });
      });

      // Step 3: Create dimensions and series
      const dimensions = ["product", ...Array.from(allYearKeys).sort()];
      let series = Object.values(groupMap);

      // Step 4: Sort series by the greatest year's target in descending order
      const targetKey = `${greatestYear}_target`;
      series.sort((a, b) => {
        const targetA = parseFloat(a[targetKey] || 0);
        const targetB = parseFloat(b[targetKey] || 0);
        return targetB - targetA;
      });

      // Step 5: Remove the target key from series and dimensions
      const newObjWithoutTarget = series.map((obj) => {
        const newObj = { ...obj };
        delete newObj[targetKey];
        return newObj;
      });
      const finalDimensions = dimensions.filter((dim) => dim !== targetKey);

      return { dimensions: finalDimensions, series: newObjWithoutTarget };
    };
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      const calChartDataSidingWise = transformYearlyData(data);
      setChartDataSidingWise(calChartDataSidingWise);
    } else {
      setChartDataSidingWise(null);
    }
  }, [data, transformYearlyData]);

  return (
    <div>
      <h6 className="m-1 p-2 bg-dark text-white">7A Loading Siding Wise </h6>
      <hr className="m-1 p-0" />

      {chartDataSidingWise ? (
        <GroupedBarChart
          data={chartDataSidingWise}
          from="7ACHWEIGHTSiding"
          chartType="bar"
        />
      ) : (
        "No Data Found"
      )}
    </div>
  );
};

export default CHWeightSidingWise;
